import { useEffect, useState } from "react";
import { useParams, NavLink,useHistory } from "react-router-dom";
import { getUser, getJobDescriptionByForAdmin,updateUserJobDescription,deleteJobDescriptionById } from "../../http";
import UpdateJobModal from "../team/team/modal/UpdateJobDescriptionModal";
import { toast, ToastContainer } from 'react-toastify';
import moment from "moment";

const Employee = () => {
  const navigate = useHistory();
  const [user, setUser] = useState({
    name: '',
    email: '',
    mobile: '',
    image: '',
    address: '',
    status: '',
    type:''
  });

  const { id } = useParams();
  const [userJob, setUserJob] = useState({});
  const [modalVisible, setModalVisible] = useState(false);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [jobToDelete, setJobToDelete] = useState(null);
  const [jobData, setJobData] = useState({
    jobTitle: '',
    jobDescription: '',
    jobLocation: '',
    team: '',
    employmentStatus: '',
    employmentType: '',
    startDate: '',
  });

  // Fetch user data
  const getUserData = async (id) => {
    const res = await getUser(id);
    if (res.data.success) setUser(res.data.data);
  };

  // Fetch job details
  const getUserJobDetails = async (id) => {
    const response = await getJobDescriptionByForAdmin(id);
   
    if (response.data.success) {
      setUserJob(response.data.data);
      setJobData(response.data.data)
    }

  };
  console.log("User Job",userJob);
 
  useEffect(() => {
    getUserData(id);
    getUserJobDetails(id);
  }, [id,setUserJob]);

  useEffect(()=>{},[

  ])

  // Sync jobData with userJob
  useEffect(() => {
    if (userJob) {
       
      setJobData({
        jobTitle: userJob?.jobTitle,
        jobDescription: userJob?.jobDescription,
        jobLocation: userJob?.jobLocation,
        team: userJob?.team,
        employmentStatus: userJob?.employmentStatus,
        employmentType: userJob?.employmentType,
        _id:userJob?._id,
        employeeID:userJob?.employeeID,
        startDate: moment(userJob?.startDate).format("YYYY-MM-DD"),
      });
    }
  }, [userJob]);

  // Handle updates from modal
  const handleUpdate = (updatedJob) => {
    // Update the userJob state with the updated job data
    setUserJob(prevUserJob => {
      if (Array.isArray(prevUserJob)) {
        // If userJob is an array, find and update the specific job
        return prevUserJob.map(job => 
          job._id === updatedJob._id ? updatedJob : job
        );
      } else {
        // If userJob is a single object, update it directly
        return updatedJob;
      }
    });
    
    // Also update the jobData state
    setJobData(updatedJob);
  };

  const DeleteJobDescription = async (id)=>{
    const response = await deleteJobDescriptionById(id);
    if(response.data.success){
      setUserJob(prevJobs => prevJobs.filter(job => job._id !== id));
      toast.success('Job Description deleted successfully!');
      setDeleteModalVisible(false);
      setJobToDelete(null);
    }else{
      toast.error('Failed to delete job description!');
    }
  };

  const handleDeleteClick = (job) => {
    setJobToDelete(job);
    setDeleteModalVisible(true);
  };
  
  return (
    <>
      <div className="main-content">
        <section className="section">
          <div className="section-header d-flex justify-content-between">
            <h1>{user.type}</h1>
            <div className="d-flex justify-between">
              <button className="btn btn-danger mr-4 pr-4 pl-4" 
                onClick={(e)=>{
                  e.preventDefault();
                  if(user.type === 'Employee'){
                    navigate.push('/employees')
                  }else if(user.type === 'Admin'){
                    navigate.push('/admins')
                  }else if(user.type === 'Leader'){
                    navigate.push('/leaders')
                  }
                }}>
                Back
              </button>
              <NavLink to={`/edituser/${id}`} className="btn btn-primary mr-4">
                Edit {user.type}
              </NavLink>
              
            </div>
          </div>

          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-3 text-center mb-4">
                  <div className="profile-image-container">
                    <img
                      className="img-fluid rounded-circle shadow"
                      src={user.image}
                      alt={user.name}
                      style={{ width: '200px', height: '200px', objectFit: 'cover' }}
                    />
                  </div>
                  <h3 className="mt-3 mb-0">{user.name}</h3>
                  <p className="text-muted">{user.type}</p>
                </div>
                
                <div className="col-md-9">
                  <div className="card">
                    <div className="card-header">
                      <h4 className="card-title mb-0">Personal Information</h4>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="info-item mb-3">
                            <label className="text-muted mb-1">Email</label>
                            <p className="mb-0">{user.email}</p>
                          </div>
                          <div className="info-item mb-3">
                            <label className="text-muted mb-1">Mobile</label>
                            <p className="mb-0">+{user?.countryCode} {user.mobile}</p>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="info-item mb-3">
                            <label className="text-muted mb-1">Country</label>
                            <p className="mb-0">{user.country}</p>
                          </div>
                          <div className="info-item mb-3">
                            <label className="text-muted mb-1">Address</label>
                            <p className="mb-0">{user.address}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card mt-4">
                    <div className="card-header">
                      <h4 className="card-title mb-0">Job Details</h4>
                    </div>
                    <div className="card-body">
                      {userJob?.length > 0 ? (
                        <div className="accordion" id="jobDetailsAccordion">
                          {Object.values(userJob.reduce((acc, job) => {
                            const teamId = job?.team?._id;
                            if (!acc[teamId]) {
                              acc[teamId] = {
                                teamName: job?.team?.name,
                                jobs: []
                              };
                            }
                            acc[teamId].jobs.push(job);
                            return acc;
                          }, {})).map((teamData, index) => (
                            <div className="card border-0 mb-3" key={teamData.teamName}>
                              <div className="card-header bg-light d-flex justify-content-between" id={`heading${index}`}>
                                <h2 className="mb-0">
                                  <button
                                    className="btn btn-link btn-block text-left text-decoration-none"
                                    type="button"
                                    data-toggle="collapse"
                                    data-target={`#collapse${index}`}
                                    aria-expanded="true"
                                    aria-controls={`collapse${index}`}
                                  >
                                    <i className="fas fa-users mr-2"></i>
                                    {teamData.teamName}
                                  </button>
                                </h2>

                                {/* Here I need to Edit the Job Description */}
                                <div className="d-flex ">
                                <button className="btn btn-primary mr-4" onClick={()=>{
                                  setModalVisible(true);
                                  setJobData(teamData.jobs[0]);
                                }}>
                                  Edit
                                </button>
                                <button className="btn btn-danger" onClick={() => 
                                  handleDeleteClick(teamData.jobs[0])
                                }>
                                  Delete 
                                </button>
                                </div>
                              </div>

                              <div
                                id={`collapse${index}`}
                                className="collapse"
                                aria-labelledby={`heading${index}`}
                                data-parent="#jobDetailsAccordion"
                              >
                                <div className="card-body">
                                  {teamData.jobs.map((job) => (
                                    <div key={job?._id} className="job-details mb-4">
                                      <div className="row">
                                        <div className="col-md-6">
                                          <div className="info-item mb-3">
                                            <label className="text-muted mb-1">Job Title</label>
                                            <p className="mb-0">{job?.jobTitle}</p>
                                          </div>
                                          <div className="info-item mb-3">
                                            <label className="text-muted mb-1">Job Description</label>
                                            <p className="mb-0">{job?.jobDescription}</p>
                                          </div>
                                          <div className="info-item mb-3">
                                            <label className="text-muted mb-1">Job Location</label>
                                            <p className="mb-0">{job?.jobLocation}</p>
                                          </div>
                                        </div>
                                        <div className="col-md-6">
                                          <div className="info-item mb-3">
                                            <label className="text-muted mb-1">Employment Status</label>
                                            <p className="mb-0">
                                              <span className={`badge ${job?.employmentStatus === 'Full-time' ? 'badge-success' : 'badge-info'}`}>
                                                {job?.employmentStatus}
                                              </span>
                                            </p>
                                          </div>
                                          <div className="info-item mb-3">
                                            <label className="text-muted mb-1">Employment Type</label>
                                            <p className="mb-0">
                                              <span className="badge badge-primary">
                                                {job?.employmentType}
                                              </span>
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div className="text-center py-4">
                          <i className="fas fa-briefcase fa-3x text-muted mb-3"></i>
                          <p className="text-muted">No job details available</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <UpdateJobModal
          visible={modalVisible}
          onClose={() => setModalVisible(false)}
          onUpdate={handleUpdate}
          initialData={jobData}
          userDetails={user}
        />
      </div>

      {/* Delete Confirmation Modal */}
      {deleteModalVisible && (
        <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Delete</h5>
                <button type="button" className="close" onClick={() => {
                  setDeleteModalVisible(false);
                  setJobToDelete(null);
                }}>
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete this job description?</p>
                {jobToDelete && (
                  <div className="alert alert-info">
                    <strong>Job Title:</strong> {jobToDelete.jobTitle}
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => {
                  setDeleteModalVisible(false);
                  setJobToDelete(null);
                }}>
                  Cancel
                </button>
                <button type="button" className="btn btn-danger" onClick={() => DeleteJobDescription(jobToDelete._id)}>
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Employee;